import { Component, OnInit, OnDestroy, NgZone, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';

import {
    AuthorizationService,
    ModelService,
    PoweredByService,
    EquipmentService,
    Equipment,
    Model,
    PoweredBy,
    PoweredBysByModel,
    GlobalService,
    DeleteConfirmation,
    ToastrService
} from './../../../../shared/index';

@Component({
    selector: 'model-entity',
    templateUrl: './model-entity.html',
    standalone: false
})

export class ModelEntityComponent implements OnInit, OnDestroy {
    @Input('model') model: Model = new Model();
    @Input('simplified') simplified = false;
    @Input('full') full = false;
    @Input('listOnly') listOnly = false;
    @Input('live') live = true;
    @Input('isDocumentPage') isDocumentPage: boolean;
    public poweredBysVisible = false
    public equipmentCount = 0;
    public processing = true;

    public subscriptions: Subscription[] = [];
    public textColor = '';
    public label: string;
    @ViewChild('DeleteModel') ModelDeleteModel: ModalDirective;
    constructor(
        private _ngZone: NgZone,
        private _modelService: ModelService,
        private _poweredByService: PoweredByService,
        private _equipmentService: EquipmentService,
        private _globalService: GlobalService,
        private _toastrService: ToastrService
    ) {
        this.subscriptions.push(this._poweredByService.poweredBysByModelChange.subscribe((info: PoweredBysByModel) => {
            this._ngZone.run(() => {
                if (info.ModelId == this.model.Id) {
                    this.model.PoweredBys.init();
                    for (const poweredBy of info.PoweredBys) {
                        this.model.PoweredBys.update($.extend(new PoweredBy(), poweredBy), true);
                    }
                    this.processing = false;
                }
            });
        }));
    }
    ngOnInit(): void {
        if (this.live) {
            this._modelService.getEquipmentCount(this.model.Id).then((value: number) => {
                this._ngZone.run(() => {
                    this.equipmentCount = value;
                });
            });
        } else {
            this._modelService.getEquipmentCountStaged(this.model.Id).then((value: number) => {
                this._ngZone.run(() => {
                    this.equipmentCount = value;
                });
            });
        }

        this.subscriptions.push(this._modelService.equipmentCountChange.subscribe((value: number) => {
            if (this.live) {
                if (value == this.model.Id) {
                    this._modelService.getEquipmentCount(this.model.Id).then((count: number) => {
                        this._ngZone.run(() => {
                            this.equipmentCount = count;
                        });
                    });
                }
            } else {
                if (value == this.model.Id) {
                    this._modelService.getEquipmentCountStaged(this.model.Id).then((count: number) => {
                        this._ngZone.run(() => {
                            this.equipmentCount = count;
                        });
                    });
                }
            }
        }));

        //if (this.full) {
        //    this.subscriptions.push(this._globalService.deleteResultEx.subscribe((result: DeleteConfirmation) => {
        //        if (result.Confirmed && result.EntityType == "model" && result.EntityId == this.model.Id) {
        //            this._modelService.delete(this.model);
        //        }
        //    }));
        //}
        this.label = this.model.Name;

    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    public addEquipment(): void {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        const equip: Equipment = new Equipment();
        equip.ModelId = this.model.Id;
        this._equipmentService.manipulate(equip);
    }

    public getPoweredBys(): void {
        this.poweredBysVisible = !this.poweredBysVisible;
        if (this.poweredBysVisible) {
            if (this.live) {
                this._poweredByService.getPoweredBysByModel(this.model.Id);
            } else {
                this._poweredByService.getPoweredBysByModelStaged(this.model.Id);
            }

        }
    }

    public showDetails(): void {
        this._modelService.showDetails(this.model);
    }

    public edit(): void {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }

        this._modelService.manipulate(this.model);
    }

    public delete(): void {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        this.ModelDeleteModel.show();
        //this._globalService.confirmDelete("model", this.model.Name, this.model.Id);
    }

    DeleteSelectedModel() {
        this.ModelDeleteModel.hide();
        this._modelService.delete(this.model);
    }
    Close(): void {
        this.ModelDeleteModel.hide();
    }
}
